export { default } from "./SpaceTableSearchBar";
